<template>
    <v-dialog v-model="isDialog" width="720px">
        <v-sheet>
            <div>
                <v-card-title class="main white--text">Внимание</v-card-title>
                <div class="body pa-4">
                    <div class="bold">
                        {{ confirmText }}
                    </div>
                    <div class="mt-2">
                        Введите слово "Удалить" для подтверждения удаления
                    </div>

                    <TextField 
                    class="mt-2"
                    placeholder="Удалить"
                    hideDetails
                    v-model="text"
                    />

                    <div class="mt-2 red--text">
                        Если вы решите восстановить удалённый источник, то сможете это сделать не ранее чем через <b>30</b> дней
                    </div>

                    <div class="footer mt-4">
                        <v-btn variant="outlined" @click="close">Отмена</v-btn>
                        <v-btn 
                        variant="contained" 
                        color="error" 
                        class="white--text" 
                        :loading="loading" 
                        @click="deleteConnectors"
                        :disabled="text !== 'Удалить'"
                        >
                            <div class="btn-inner">
                                <v-icon size="20" color="white">mdi-delete-outline</v-icon>
                                Удалить
                            </div>
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-sheet>
    </v-dialog>
</template>
<script>
import Vue, { PropType } from 'vue'
import TextField from '../../inputs/TextField.vue'
import { CHANNEL_TYPES } from '@/vars/general'
import {
    getCascadesByProject,
    getCascadeById,
    deleteCascadeChannel,
    updateCascadeChannelsPriorities,
} from '@/api/networkFixer'

export default Vue.extend({
    components: { TextField },
    props: {
        value: { type: Boolean },
        connectors : {type : Array}
    },
    data: () => ({
        loading : false,
        text : ""
    }),
    computed: {
        isDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        isSingle() {
            return this.connectors.length > 1 ? false : true
        },
        connectorsCount() {
            return this.connectors.length
        },
        confirmText() {
            if (this.isSingle) {
                return "Вы действительно хотите удалить выбранный источник?"
            } else {
                return `Вы действительно хотите удалить выбранные источники (${this.connectorsCount})?`
            }
        }
    },
    methods: {
        async removeConnectorsFromCascades() {
            const connectorsToDelete = (this.connectors || [])
                .map((connectorId) => this.$store.getters['connectorById'](connectorId))
                .filter(Boolean)

            const channelConnectors = connectorsToDelete.filter((connector) =>
                Object.values(CHANNEL_TYPES).includes(connector.connectorType) && connector.channelId
            )
            if (!channelConnectors.length) return

            const channelIdsByProject = channelConnectors.reduce((acc, connector) => {
                const projectId = connector.projectId
                const numericChannelId = Number(connector.channelId)
                if (!projectId || !Number.isFinite(numericChannelId)) return acc
                if (!acc[projectId]) acc[projectId] = new Set()
                acc[projectId].add(numericChannelId)
                return acc
            }, {})

            const projectIds = Object.keys(channelIdsByProject)
            for (const projectId of projectIds) {
                const { data: cascades, error: cascadesError } = await getCascadesByProject(projectId)
                if (cascadesError || !Array.isArray(cascades)) continue

                for (const cascade of cascades) {
                    const channelsToRemove = (cascade.channels || []).filter((cascadeChannel) =>
                        channelIdsByProject[projectId].has(Number(cascadeChannel.channelId))
                    )
                    if (!channelsToRemove.length) continue

                    for (const cascadeChannel of channelsToRemove) {
                        if (!cascadeChannel?.id) continue
                        await deleteCascadeChannel(cascadeChannel.id)
                    }

                    const refreshedCascade = await getCascadeById(cascade.id)
                    const refreshedChannels = refreshedCascade?.data?.channels || []
                    const normalizedChannels = [...refreshedChannels]
                        .filter(channel => channel?.channelId !== null && channel?.channelId !== undefined)
                        .sort((a, b) => Number(a.priority || 0) - Number(b.priority || 0))
                        .map((channel, index) => ({
                            channelId: Number(channel.channelId),
                            priority: index + 1,
                        }))
                        .filter(channel => Number.isFinite(channel.channelId))

                    if (!normalizedChannels.length) continue
                    await updateCascadeChannelsPriorities({
                        cascadeId: cascade.id,
                        channels: normalizedChannels,
                    })
                }
            }
        },
        async deleteConnectors() {
            this.loading = true

            // Определяем до удаления, есть ли среди удаляемых элементов каналы (чтобы обновить приоритеты)
            const isAnyChannel = (this.connectors || []).some((connectorId) => {
                const c = this.$store.getters['connectorById'](connectorId)
                return c && Object.values(CHANNEL_TYPES).includes(c.connectorType)
            })

            if (isAnyChannel) {
                try {
                    await this.removeConnectorsFromCascades()
                } catch (e) {
                    console.error('Ошибка удаления каналов из каскадов:', e)
                }
            }

            let promises = []
            for (const connectorId of this.connectors) {
                promises.push(this.$store.dispatch('project/deleteConnector', connectorId))
            }
            await Promise.all(promises)

            // После удаления канала нужно заново запросить приоритеты (сброс кеша в таблице и повторная загрузка)
            if (isAnyChannel) {
                try {
                    this.$root.$emit('reload-channel-priorities')
                    this.$root.$emit('reload-project-promos')
                } catch (e) {
                    // ignore
                }
            }

            this.loading = false
            this.close()
        },

        close() {
            this.text = ''
            this.isDialog = false
        },
    }
})
</script>

<style lang="scss" scoped>
    .bold {
        font-weight: 600;
    }
  .footer {
    display: flex;
    justify-content: space-between;
  }

  .btn-inner {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;

    i {
        margin-top: -2px;
    }
  }

</style>
